import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import ButtonIconH from "./ButtonIconH";
import Tag from "./Tag";
import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import { useOptics } from "../hooks/useOptics";
import { useBrands } from "../hooks/useBrands";
import { userData } from "../js/utils";
import { post } from "../js/post";
import GoDexLabelMultiplePopup from "./GoDexLabelMultiplePopup";
import { printCode } from "../devices/godex";

export function DeliveryNoteLabelEncoding({
  deliveryNoteId,
  selectedDistributionStock,
  productFamilyName,
  productFamilyId,
  list,
  columns,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [productList, setProductList] = useState(list);
  const [selectedBrandList, setSelectedBrandList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [brandList] = useBrands(productFamilyId, -1, "");
  const opticalList = [
    { id: "", text: "" },
    ...useOptics().map((e) => ({ id: e.id, text: e.text })),
  ];
  const [selectedOptic, setSelectedOptic] = useState("");
  const [selectedProductCodes, setSelectedProductCodes] = useState([]);
  const [goDexPopup, setGoDexPopup] = useState(false);
  const [productDataForPrintLabel, setProductDataForPrintLabel] = useState([]);
  const [directPrinting, setDirectPrinting] = useState(false);

  // console.log("selectedItems: ", selectedItems);
  // console.log("selectedProductCodes: ", selectedProductCodes);
  // console.log("productDataForPrintLabel: ", productDataForPrintLabel);
  // console.log("productList: ", productList);
  // console.log("selectedOptic: ", selectedOptic);

  function handleSelectAll() {
    setSelectedItems((prev) => [
      ...prev,
      ...productList
        .filter(({ idProductoAlbaran }) => !prev.includes(idProductoAlbaran))
        .map(({ idProductoAlbaran }) => idProductoAlbaran),
    ]);
  }

  function handleCleanSelected() {
    setSelectedItems([]);
  }

  function handleCleanValues() {
    setSelectedBrandList([]);
    setSelectedOptic("");
    setSelectedItems([]);
    setProductDataForPrintLabel([]);
  }

  function handleCheckboxChange(productId) {
    setSelectedItems((prevSelected) =>
      prevSelected.includes(productId)
        ? prevSelected.filter((id) => id !== productId)
        : [...prevSelected, productId],
    );
  }

  const getProductLabelData = async () => {
    if (selectedProductCodes.length > 0) {
      const response = await post(
        "support-extra/albaran/ObtenerDatosProductosEtiquetasAlbaran.php",
        {
          idAlbaran: deliveryNoteId,
          token: userData.token,
          idOptica: selectedOptic,
          codigos: selectedProductCodes,
        },
      );
      // console.log(
        // ">>> OBTENIENDO DATOS PARA IMPRIMIR: ",
        // {
          // idAlbaran: deliveryNoteId,
          // token: userData.token,
          // idOptica: selectedOptic,
          // codigos: selectedProductCodes,
        // },
        // response,
      // );

      setProductDataForPrintLabel(response);
    } else setProductDataForPrintLabel([]);
  };

  const columnsWithInputs = columns.map((col) => {
    if (col.id === "code") {
      return {
        ...col,
        selector: (row) => (
          <button
            onClick={() => {
              setSelectedProductCodes([row.codigo]);
              setDirectPrinting(true);
              setGoDexPopup(true);
            }}
          >
            <img
              src={"/images/code-blue.svg"}
              className="icon-pref"
              alt="Imprimir etiqueta"
            ></img>
          </button>
        ),
      };
    }
    if (col.name === "") {
      return {
        ...col,
        selector: (row) =>
          row.idProductoAlbaran !== "summary" ? (
            <CheckBox
              active={selectedItems.includes(row.idProductoAlbaran)}
              onClick={() => handleCheckboxChange(row.idProductoAlbaran)}
            />
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  useEffect(() => {
    const codes = productList
      .filter((p) => selectedItems.includes(p.idProductoAlbaran))
      .map((p) => p.codigo);
    setSelectedProductCodes(codes);
  }, [selectedItems]);

  useEffect(() => {
    getProductLabelData();
  }, [selectedProductCodes]);

  useEffect(() => {
    const filtered = list.filter((e) => {
      const brandMatch =
        selectedBrandList.length === 0 || selectedBrandList.includes(e.marca);
      const opticMatch =
        selectedOptic === "" ? true : e.opticas?.includes(selectedOptic);
      return brandMatch && opticMatch;
    });
    setProductList(filtered);
    const filteredIds = new Set(filtered.map((e) => e.idProductoAlbaran));
    setSelectedItems((prev) => prev.filter((id) => filteredIds.has(id)));
  }, [selectedBrandList, selectedOptic]);

  return (
    <>
      {goDexPopup && (
        <GoDexLabelMultiplePopup
          directPrinting={directPrinting}
          products={productDataForPrintLabel}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onClose={() => {
            setGoDexPopup(false);
            setDirectPrinting(false);
          }}
        />
      )}
      {productList.length > 0 && (
        <div className="delivery-note-table-info-container">
          <div className="opt-table-title">
            {productFamilyName} ({productList.length})
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <button
              className="cell-label"
              onClick={handleCleanValues}
              tabIndex={-1}
            >
              Limpiar filtros
            </button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              padding: "10px 0 20px 0",
            }}
          >
            <div className="data-field">
              <span className="label">Marca</span>
              <InputIconSearchPanelMultiSelection
                size={3}
                type={"type-alphanum-ext"}
                options={brandList}
                selectedOptions={selectedBrandList}
                onChange={(e) => {
                  setSelectedBrandList(e);
                }}
              ></InputIconSearchPanelMultiSelection>
            </div>
            {selectedDistributionStock === "Multicompra" && (
              <div className="data-field">
                <span className="label"> Distribución por óptica</span>
                <Dropdown
                  optionList={opticalList}
                  size={3}
                  op={selectedOptic}
                  onChange={(e) => {
                    setSelectedOptic(e.id);
                  }}
                ></Dropdown>
              </div>
            )}
            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "flex-end",
                flex: 1,
              }}
            >
              <ButtonIconH
                disabled={selectedItems.length === 0}
                text={"Imprimir selección"}
                small={true}
                onClick={() => {
                  setGoDexPopup(true);
                }}
              ></ButtonIconH>
            </div>
          </div>
          {selectedBrandList.length > 0 && (
            <span style={{ fontWeight: "500", marginBottom: 10, fontSize: 13 }}>
              Marcas seleccionadas: {selectedBrandList.length}
            </span>
          )}
          <div
            className="tag-content"
            style={{ maxHeight: "max-content", marginBottom: 20 }}
          >
            {selectedBrandList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedBrandList((prevBrands) =>
                      prevBrands.filter((brand) => brand !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "5px",
              justifyContent: "flex-end",
              paddingBottom: 10,
            }}
          >
            <button
              className="cell-label"
              onClick={handleSelectAll}
              tabIndex={-1}
            >
              Seleccionar todos
            </button>
            |
            <button
              className="cell-label"
              onClick={handleCleanSelected}
              tabIndex={-1}
            >
              Limpiar selección
            </button>
          </div>
          <div className="store-products-table delivery-note-table">
            <DataTable
              columns={columnsWithInputs}
              data={productList}
              noDataComponent="No hay datos disponibles."
              className="custom-datatable non-interactive"
            />
          </div>
        </div>
      )}
    </>
  );
}
